module.exports = __webpack_public_path__ + "static/Creator 19 - @NarcolepticNugget-f8ce952864a3bf3e34fa67ed07293fd0.png";